import React, { useState } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
// Components
import Slider from "react-slick";
import Modal from "../../ui/modal/Modal";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";
// interfaces
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
// Styles
import "./BenefitsCarouselMpc.scss";
import { useLocation } from '@reach/router';

const BenefitsCarouselMpc = (props: ReferenciaContenido) => {
    const { tituloGeneral, tituloBoton, redireccionBoton, referenciaPlantillaContenido: refPlantilla } = props;
    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState(0);
    const [displayModal, setDisplayModal] = useState(false);
    const location = useLocation();
    const hasPathSegment = location.pathname.includes('proyectos-inclusion-laboral/por-talento/');

    const CarouselServices = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 1.35,
                    dots:true,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < refPlantilla.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    
    // Función para agregarle parametros a una etiqueta anchor anidada en un string
    const processLinkNode = (node) => {
        if (node.nodeType === 'hyperlink' && node.data.uri) {
          return (
            <>
                <br />
                <br />
                <a href={node.data.uri} target="_blank" rel="noopener noreferrer">
                    {node.content[0].value}
                </a>
            </>
          );
        }
        return null;
      };

    return (
        <div className="o-benefits-mpc">
            <div className={`o-benefits-mpc__contentTop ${hasPathSegment ? "contentTopCentered" : ""}`}>
            <div className={`container_title ${hasPathSegment ? "centered" : ""}`}>
                    <h2 className="o-benefits-mpc__title">{tituloGeneral}</h2>
                </div>
                {!hasPathSegment && refPlantilla.length > 4 &&
                    <div className="arrows-slider">
                        <PreviousArrowButton canGoPrev={sliderIndex > 0} onClick={goToBack}/>
                        <NextArrowButton canGoNext={sliderIndex < refPlantilla.length - 4} onClick={goToNext}/>
                    </div>
                }
            </div>
            <div className="container_carrusel">
                <div className={`o-benefits-mpc__container`}>
                    <Slider
                        ref={(c) => {
                            setSlider(c);
                        }}
                        {...CarouselServices}
                    >
                        {refPlantilla.map((item, index) => (
                            <div
                                className={`o-benefits-mpc__item gtmPersonasClickButton-${item.tituloBanner && item.tituloBanner
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f :,.]/g, "")}`}
                                key={index}
                            >
                                <a
                                    href={item.redireccionBoton}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div className="o-benefits-mpc_cardContainer">
                                        <div className={`o-benefits-mpc__item__contentImage ${hasPathSegment ? "contentImageBenefits" : ""}`}>
                                            <figure className={hasPathSegment ? "expanded" : ""}>
                                                <img src={item.imagenPrincipal[0]?.file.url}
                                                    alt={item.tituloBanner}
                                                    className={hasPathSegment ? "mode-icon" : "light-mode-icon"}
                                                />
                                            </figure>
                                        </div>
                                        <div className="o-benefits-mpc__contentCards">
                                            <h3>{item.tituloBanner}</h3>
                                            <h4>{item.tituloDescripcion}</h4>
                                            <p>
                                                {item.descripcion && item.descripcion.json &&
                                                    documentToReactComponents(
                                                        item.descripcion.json , {
                                                            renderNode: {
                                                              'hyperlink': processLinkNode,
                                                            },
                                                          }
                                                    )}
                                            </p>
                                            <br />
                                            {
                                                item.tituloBoton && 
                                                    <button
                                                    className={hasPathSegment ? "underline-button" : ""}
                                                        onClick={
                                                            () =>{setDisplayModal(!displayModal);}
                                                        }
                                                    >
                                                        {item.tituloBoton}
                                                    </button>                                                
                                            }
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
                {tituloBoton && (
                    <button
                        className={`o-benefits-mpc__button`}
                        onClick={() => {
                            window.open(redireccionBoton, "_blank");
                        }}
                    >
                        {tituloBoton}
                    </button>
                )}
            </div>
                {/* Renderiza el modal */}
                {displayModal && (
                <Modal 
                    showModal={displayModal} 
                    onClose={function (): void {
                        setDisplayModal(!displayModal);
                        }}                
                >
                    <div className="m-modal-container-benefitsCarousellMpc">
                        <h3>
                            {refPlantilla[0].referenciaContenido[0].titulo}
                        </h3>
                        <div className="m-modal-container-benefitsCarousellMpc__paragraph">
                            <p>
                                {documentToReactComponents(refPlantilla[0].referenciaContenido[0].descripcion.json)}
                            </p>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default BenefitsCarouselMpc;
